import { useDocument } from 'react-firebase-hooks/firestore';
import { doc } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, firestore } from '../firebase/firebase';

export const useShowBanner = () => {
  const [authUser, authLoading] = useAuthState(auth);

  const [userDoc, userDocLoading] = useDocument(
    authUser?.uid ? doc(firestore, 'users', authUser.uid) : null,
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );

  const shouldShowBanner =
    userDoc?.data()?.shouldMigrateToNewDashboard === true;

  return {
    shouldShowBanner,
    loading: authLoading || userDocLoading,
  };
};
